/* @flow */

export default class UserCompanyRoleSeller {
  canExecute: boolean;
  canRequestOffers: boolean;
  hasActiveFixContract: boolean;
  hasSoldInvoices: boolean;
  isActive: boolean;
}
